var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-corner-decoration",style:(_vm.elStyle)},[_c('div',{staticClass:"m-corner-decoration__body"},[_c('div',{staticClass:"m-corner-decoration__main"},[(_vm.$slots.default)?_vm._t("default"):_c('span',[_vm._v(_vm._s(_vm.text))])],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }